import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withAsyncActions } from 'react-async-client';
import { assocPath, path } from 'ramda';
import Translate from 'react-translate-component';
import { message } from 'antd';

import { closedState } from 'constants/scenario';
import { modalPropTypes } from 'components/Modals';
import DocumentScript from 'components/cards/document/preview/DocumentScript';
import { getScenarioTest, postScenarioTest } from 'actions/asyncActions';
import ModalContainer from 'components/modals/ModalContainer';

@withAsyncActions({
    getScenarioTest: getScenarioTest
        .withPayload(({ params: { id, type, cmd } }) => ({ objtype: type, objkey: id, cmd }))
        .withOptions({ dispatchOnMount: true }),
    postScenarioTest: postScenarioTest
        .withSuccessHandler(({ close }, { requestAction: { payload } }) => {
            if (!payload.draftStatus) {
                close();
            }
        })
        .withErrorHandler(() => message.error(<Translate content="errors.saveError" />)),
})
class ScenarioTestModal extends Component {
    static propTypes = {
        ...modalPropTypes,
        getScenarioTest: PropTypes.object.isRequired
    }

    sendTest = (body, draftStatus = false) => {
        const { data } = this.props.getScenarioTest;

        this.props.postScenarioTest.dispatch({
            cmd: this.props.params.cmd,
            body,
            type: 'OnlineTest',
            id: data.object.id,
            draftStatus,
        });
    }

    saveTest = body => {
        this.sendTest(body, true);
    }

    finishTest = body => {
        this.sendTest(body);
    }

    render() {
        const { modal, getScenarioTest: { data: test, meta }, params: { name, token, cmd } } = this.props;
        var body;

        if (meta.success) {
            const closed = path(['data', 'state'], test) === closedState;
            body = closed ? assocPath(['options', 'view_mode'], true, test.body) : test.body;
        }

        return (
            <ModalContainer
                meta={meta}
                modal={modal}
                title={name}
                className="modal-full card-modal scenario-modal"
            >
                { meta.success && (
                    <DocumentScript
                        body={body}
                        token={token}
                        cmd={cmd}
                        onAbort={this.saveTest}
                        onComplete={this.finishTest}
                        button={null}
                    />
                )}
            </ModalContainer>
        )
    }
}

ScenarioTestModal.width = '90%';

export default ScenarioTestModal;
